import React from 'react';

export interface KnowMeTypography {
  bodyText: React.CSSProperties;
  capitalLettersBold: React.CSSProperties;
  capitalLettersRegular: React.CSSProperties;
  f12Regular: React.CSSProperties;
  f14Medium: React.CSSProperties;
  f14Regular: React.CSSProperties;
  f16Medium: React.CSSProperties;
  f16Regular: React.CSSProperties;
  f20Medium: React.CSSProperties;
  f20Regular: React.CSSProperties;
  f24Medium: React.CSSProperties;
  headerMedium: React.CSSProperties;
  headerRegular: React.CSSProperties;

  newBodySmallText: React.CSSProperties;
  newBodyText: React.CSSProperties;
  newCapitalLettersMedium: React.CSSProperties;
  newCapitalLettersSemiBold: React.CSSProperties;
  newContentHeader: React.CSSProperties;
  newF16Medium: React.CSSProperties;
  newF16SemiBold: React.CSSProperties;
  newF20Medium: React.CSSProperties;
  newF20Regular: React.CSSProperties;
  newF20SemiBold: React.CSSProperties;
  newF24Medium: React.CSSProperties;
  newF24SemiBold: React.CSSProperties;
  newHeader: React.CSSProperties;
  newItalicText: React.CSSProperties;
  newSubHeader: React.CSSProperties;
  newTagText: React.CSSProperties;

  subHeaderLarge: React.CSSProperties;
  subHeaderMedium: React.CSSProperties;

  weightBold: number;
  weightMedium: number;
  weightRegular: number;
  weightSemiBold: number;
}

export interface KnowMeTypographyOverrides {
  bodyText: true;
  capitalLettersBold: true;
  capitalLettersRegular: true;
  f12Regular: true;
  f14Medium: true;
  f14Regular: true;
  f16Medium: true;
  f16Regular: true;
  f20Medium: true;
  f20Regular: true;
  f24Medium: true;
  fontFamily: true;
  headerMedium: true;
  headerRegular: true;

  newBodySmallText: true;
  newBodyText: true;
  newCapitalLettersMedium: true;
  newCapitalLettersSemiBold: true;
  newContentHeader: true;
  newF16Medium: true;
  newF16SemiBold: true;
  newF20Medium: true;
  newF20Regular: true;
  newF20SemiBold: true;
  newF24Medium: true;
  newF24SemiBold: true;
  newHeader: true;
  newItalicText: true;
  newSubHeader: true;
  newTagText: true;

  subHeaderLarge: true;
  subHeaderMedium: true;
  weightBold: true;
  weightMedium: true;
  weightRegular: true;
  weightSemiBold: true;
}

export const typography: KnowMeTypography = {
  bodyText: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.2px',
    lineHeight: 1.83,
  },
  capitalLettersBold: {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '1px',
    lineHeight: 1.6,
    textTransform: 'uppercase' as const,
  },
  capitalLettersRegular: {
    fontSize: '10px',
    fontWeight: 300,
    letterSpacing: '1px',
    lineHeight: 1.4,
    textTransform: 'uppercase' as const,
  },
  f12Regular: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '16px',
    textAlign: 'left',
  },
  f14Medium: {
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '22px',
    textAlign: 'left',
  },
  f14Regular: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '22px',
    textAlign: 'left',
  },
  f16Medium: {
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '24px',
    textAlign: 'left',
  },
  f16Regular: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '24px',
    textAlign: 'left',
  },
  f20Medium: {
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '30px',
    textAlign: 'left',
  },
  f20Regular: {
    fontSize: '20px',
    fontWeight: 400,
    letterSpacing: '0em',
    lineHeight: '30px',
    textAlign: 'left',
  },
  // new typography
  f24Medium: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0em',
    lineHeight: '32px',
    textAlign: 'left',
  },
  // Headers
  headerMedium: {
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: 1.5,
  },
  headerRegular: {
    fontSize: '20px',
    fontWeight: 300,
    letterSpacing: '0.2px',
    lineHeight: 1.5,
  },

  // New typography styles (slowly replacing the old ones)

  newBodySmallText: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  newBodyText: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  newCapitalLettersMedium: {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.15px',
    textTransform: 'uppercase',
  },
  newCapitalLettersSemiBold: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0.15px',
    textTransform: 'uppercase',
  },
  newContentHeader: {
    fontSize: '36px',
    fontWeight: 500,
    letterSpacing: '0%',
  },
  newF16Medium: {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  newF16SemiBold: {
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.15px',
  },
  newF20Medium: {
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  newF20Regular: {
    fontSize: '20px',
    fontWeight: 400,
    letterSpacing: '0%',
  },
  newF20SemiBold: {
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0.15px',
  },
  newF24Medium: {
    fontSize: '24px',
    fontWeight: 500,
    letterSpacing: '0%',
  },
  newF24SemiBold: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0%',
  },
  newHeader: {
    fontSize: '48px',
    fontWeight: 500,
    letterSpacing: '0%',
  },
  newItalicText: {
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: 400,
    letterSpacing: '0.15px',
  },
  newSubHeader: {
    fontSize: '24px',
    fontWeight: 500,
    letterSpacing: '0%',
  },
  newTagText: {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },

  subHeaderLarge: {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.2px',
    lineHeight: 1.88,
  },

  subHeaderMedium: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: 1.71,
  },

  // Font Weight
  weightBold: 700,
  weightMedium: 500,
  weightRegular: 400,
  weightSemiBold: 600,
} as const;
